module.exports = {
      id: "socialshare-usage",
      viewBox: "0 0 23.63 25.957",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#socialshare",
      toString: function () {
        return this.url;
      }
    }